const styles = `:host {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  column-gap: var(--goto-spacing-02);
}
:host ::slotted(chameleon-tile) {
  width: 100%;
}`; export default styles;